// extracted by mini-css-extract-plugin
export default {"switcher":"CollapseSwitcher_switcher__KQX71","switcher__mode":"CollapseSwitcher_switcher__mode__9aaKv","switcher__mode--active":"CollapseSwitcher_switcher__mode--active__nX-yg"};